import { Link, NavLink, useNavigate } from "react-router-dom";
import { Orbit, LogOut, Sparkles } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const links = [
  { to: "/universe", label: "Galaxy Map", id: "nav-universe-link" },
  { to: "/library", label: "Library", id: "nav-library-link" },
  { to: "/feed", label: "Signals", id: "nav-feed-link" },
];

export const Header = ({ onSignIn }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className="sticky top-4 z-40 mx-auto max-w-7xl px-4" data-testid="app-header">
      <div className="glass-strong rounded-full px-5 sm:px-7 py-3 flex items-center justify-between">
        <Link to={user ? "/universe" : "/"} className="flex items-center gap-3 group" data-testid="header-logo-link">
          <span className="relative flex h-8 w-8 items-center justify-center">
            <span className="absolute inset-0 rounded-full border border-cyan-400/40 animate-pulse-ring" />
            <Orbit className="h-5 w-5 text-cyan-300 transition-transform duration-500 group-hover:rotate-90" />
          </span>
          <span className="font-display text-sm font-bold tracking-[0.3em] text-slate-100">UNIVERSE</span>
        </Link>

        {user ? (
          <nav className="hidden md:flex items-center gap-1" data-testid="main-nav">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} data-testid={l.id}
                className={({ isActive }) =>
                  `font-mono text-[0.68rem] uppercase tracking-[0.22em] px-4 py-2 rounded-full transition-colors duration-200 ${
                    isActive ? "text-cyan-300 bg-cyan-500/10" : "text-slate-400 hover:text-slate-100 hover:bg-white/5"}`}>
                {l.label}
              </NavLink>
            ))}
          </nav>
        ) : null}

        <div className="flex items-center gap-3">
          {user ? (
            <>
              <span className="hidden sm:block font-mono text-[0.68rem] uppercase tracking-[0.2em] text-slate-400" data-testid="header-user-name">
                {user.name}
              </span>
              <button onClick={handleLogout} className="btn-ghost !px-3 !py-2" data-testid="logout-button" title="Sign out">
                <LogOut className="h-3.5 w-3.5" />
              </button>
            </>
          ) : (
            <button onClick={onSignIn} className="btn-primary !py-2.5 !px-5" data-testid="header-signin-button">
              <Sparkles className="h-3.5 w-3.5" /> Sign in
            </button>
          )}
        </div>
      </div>
    </header>
  );
};
